import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import MyAccount from '../MyAccount';
import Util from '../../helper/Util';
import { Link, useLocation } from 'react-router-dom';
import { Translate } from '../../localization';
import { Select, MenuItem, Menu, NativeSelect } from '@material-ui/core';
import { connect } from 'react-redux';
import { setOddType } from '../../store/actions/user.actions';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';



const InnerLinks = (props) => {
    const [showMyBets, setShowMyBets] = useState(false);
    let defaultOddType = localStorage.getItem('oddType') ? localStorage.getItem('oddType') : props.oddType;
    const [oddType, setOddType] = useState(defaultOddType);
    const [age, setAge] = useState('');
    const isLoggedIn = Util.isLoggedIn();
    const location = useLocation();
    const handleChange = (event) => {
        setAge(event.target.value);
    };

    const handelOddsTypeChange = (e) => {
        setOddType(e.target.value);
        localStorage.setItem('oddType', e.target.value);
        props.setOddType(e.target.value);

    };

    const isFavActive = useMemo(() => location.pathname.split('/')[2] === 'favorites', [location]);

    const openMyBets = () => {
        if (isLoggedIn) setShowMyBets(true);
    };
    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),

        },
    }));
    const classes = useStyles();

    return (
        <div className="inner-links d-flex align-items-center ">
            <ul className="d-flex justify-content-between w-100">
                <div>
                    <li>
                        {/* <NativeSelect
                            
                            value={oddType} 
                            onChange={handelOddsTypeChange}
                        >
                            <option value="decimal">
                                {Translate.decimal}
                            </option>
                            <option  value="fraction">
                                {Translate.fraction}
                            </option>
                            <option  value="american">
                                {Translate.americanOdds}
                            </option>
                            
                        </NativeSelect> */}

                        <FormControl className={classes.formControl}>
                            {/* <InputLabel id="demo-simple-select-helper-label">Decimal</InputLabel> */}
                            <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                value={oddType}
                                onChange={handelOddsTypeChange}
                            >
                                <MenuItem value="decimal" >{Translate.decimal}</MenuItem>
                                <MenuItem value="fraction">{Translate.fraction}</MenuItem>
                                <MenuItem value="american">{Translate.americanOdds}</MenuItem>
                            </Select>
                        </FormControl>

                        {/* <div className="odd_type_menu">
                            <div className="oddTypesDropDown">
                                <div className="oddTypesDropdownItem">Decimal</div>
                            </div>
                            <div className="odd_type_label" >
                                Odd Type
                            </div>
                        </div> */}
                    </li>
                </div>
                <li className="ml-auto">
                    <Link to={isLoggedIn ? `/${Translate.getLanguage()}/d/favorites` : null} className={`${isFavActive && 'active'} ${!isLoggedIn && 'disabled'}`}>
                        <img src="/images/star-24px.svg" />
                        {Translate.favorites}
                    </Link>
                </li>
                {<li className="my-bets" onClick={() => openMyBets()}><a href className={`${showMyBets && 'active'} ${!isLoggedIn && 'disabled'}`}>
                    <img className="dark-theme-icon" src="/images/receipt-24px-white.svg" />
                    <img className="light-theme-icon" src="/images/receipt-24px-white.svg" />
                    {Translate.myBets} </a></li>}
            </ul>
            {showMyBets && <MyAccount onClose={() => setShowMyBets(false)} enableMyBets />}
        </div>
    );
};

InnerLinks.propTypes = {
    userData: PropTypes.object,
    setLanguage: PropTypes.func,
    language: PropTypes.string,
    headerClassname: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        oddType: state.user.oddType
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOddType: (type) => dispatch(setOddType(type))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(InnerLinks);
